import React from 'react'


function Hero() {
    return (
        <div className='bg-light p-4'>
            <div className='row p-5'>
                <div style={{display: 'flex', paddingInline: '3rem', justifyContent: 'space-between'}}>
                    <p  style={{fontWeight:'bold'}}className='fs-1'>Support Portal</p>
                    <button className='btn btn-primary fs-5 mb-5' style={{ width: "15%" }}>My tickets</button>
                </div>
                <div className='row' style={{height: '4rem', width:'100%'}}>
                    <div class="input-group">
                        <span class="input-group-text" id="visible-addon"><i class="fa fa-search" aria-hidden="true"></i></span>
                        <input type="text" class="form-control" placeholder="Eg: How do i open my account, How do i activate F&O..." aria-label="Username" aria-describedby="visible-addon" />
                    </div>
                 </div>
             </div>
        </div>
            );
}

export default Hero;